/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSearchFilter } from './InternalApiSearchFilter';
import {
    InternalApiSearchFilterFromJSON,
    InternalApiSearchFilterFromJSONTyped,
    InternalApiSearchFilterToJSON,
    InternalApiSearchFilterToJSONTyped,
} from './InternalApiSearchFilter';
import type { InternalApiLogicalOperator } from './InternalApiLogicalOperator';
import {
    InternalApiLogicalOperatorFromJSON,
    InternalApiLogicalOperatorFromJSONTyped,
    InternalApiLogicalOperatorToJSON,
    InternalApiLogicalOperatorToJSONTyped,
} from './InternalApiLogicalOperator';
import type { InternalApiSortDirection } from './InternalApiSortDirection';
import {
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionFromJSONTyped,
    InternalApiSortDirectionToJSON,
    InternalApiSortDirectionToJSONTyped,
} from './InternalApiSortDirection';

/**
 * 
 * @export
 * @interface InternalApiTransactionSearchQuery
 */
export interface InternalApiTransactionSearchQuery {
    /**
     * 
     * @type {string}
     * @memberof InternalApiTransactionSearchQuery
     */
    orderBy?: string;
    /**
     * 
     * @type {InternalApiSortDirection}
     * @memberof InternalApiTransactionSearchQuery
     */
    direction?: InternalApiSortDirection;
    /**
     * 
     * @type {Array<InternalApiSearchFilter>}
     * @memberof InternalApiTransactionSearchQuery
     */
    filters: Array<InternalApiSearchFilter>;
    /**
     * 
     * @type {InternalApiLogicalOperator}
     * @memberof InternalApiTransactionSearchQuery
     */
    logicalOperator: InternalApiLogicalOperator;
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionSearchQuery
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionSearchQuery
     */
    size: number;
}



/**
 * Check if a given object implements the InternalApiTransactionSearchQuery interface.
 */
export function instanceOfInternalApiTransactionSearchQuery(value: object): value is InternalApiTransactionSearchQuery {
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('logicalOperator' in value) || value['logicalOperator'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function InternalApiTransactionSearchQueryFromJSON(json: any): InternalApiTransactionSearchQuery {
    return InternalApiTransactionSearchQueryFromJSONTyped(json, false);
}

export function InternalApiTransactionSearchQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionSearchQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'direction': json['direction'] == null ? undefined : InternalApiSortDirectionFromJSON(json['direction']),
        'filters': ((json['filters'] as Array<any>).map(InternalApiSearchFilterFromJSON)),
        'logicalOperator': InternalApiLogicalOperatorFromJSON(json['logicalOperator']),
        'page': json['page'],
        'size': json['size'],
    };
}

export function InternalApiTransactionSearchQueryToJSON(json: any): InternalApiTransactionSearchQuery {
    return InternalApiTransactionSearchQueryToJSONTyped(json, false);
}

export function InternalApiTransactionSearchQueryToJSONTyped(value?: InternalApiTransactionSearchQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': value['orderBy'],
        'direction': InternalApiSortDirectionToJSON(value['direction']),
        'filters': ((value['filters'] as Array<any>).map(InternalApiSearchFilterToJSON)),
        'logicalOperator': InternalApiLogicalOperatorToJSON(value['logicalOperator']),
        'page': value['page'],
        'size': value['size'],
    };
}

